import type { Event } from '@lb/domain'

/**
 * Who is giving an event, as one line: « Krysta Letto, psychoéducatrice » for
 * one host, « Krysta Letto et Sarah Hamel » for two (Asana 1219455531782099).
 *
 * With two people the credentials are dropped — two names with two titles is a
 * paragraph on a card — and the names are joined in the reader's language
 * (« et », « and ») by `Intl.ListFormat` rather than a string of ours. The same
 * person entered twice is one name. Null when nobody is named.
 */
export function eventHosts(
  event: Pick<Event, 'host'> & { contributor?: Event['contributor'] },
  language: string,
): string | null {
  const host = event.host ?? null
  const cohost = event.contributor && event.contributor.id !== host?.id ? event.contributor : null

  if (host && cohost) {
    return new Intl.ListFormat(language, { style: 'long', type: 'conjunction' }).format([
      host.fullName,
      cohost.fullName,
    ])
  }

  const one = host ?? cohost
  if (!one) return null
  return one.credential ? `${one.fullName}, ${one.credential}` : one.fullName
}
